var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"lx-pacman-loader"},[_c('img',{attrs:{"src":"/static/images/common/pacman.gif","width":_vm.width}})])}
var staticRenderFns = []

export { render, staticRenderFns }